import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class EducationAuthority extends HrCommonAuthority {

    public static readonly EDUCATION_BASE = 'education';

    constructor(authority: string) {
        super(combineAuth(EducationAuthority.EDUCATION_BASE, authority));
    }

}
